function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.165,0.0001 C15.385,0.0001 15.497,0.2621 15.348,0.4211 L3.781,12.7101 C3.593,12.9111 3.329,13.0251 3.053,13.0251 L2.005,13.0251 C0.897,13.0251 0,12.1281 0,11.0211 L0,2.0001 C0,0.8961 0.895,0.0001 2,0.0001 L15.165,0.0001 Z M18.335,0.1661 C18.4,0.0971 18.502,0.0651 18.593,0.0941 C19.407,0.3471 20,1.1041 20,2.0051 L20,11.0251 C20,12.1301 19.105,13.0251 18,13.0251 L17.5,13.0251 C17.224,13.0251 17,13.2491 17,13.5261 L17,15.4991 C17,15.9831 16.381,16.1851 16.096,15.7931 L14.293,13.3181 C14.106,13.1311 13.851,13.0251 13.586,13.0251 L6.812,13.0251 C6.592,13.0251 6.48,12.7631 6.629,12.6041 L18.335,0.1661 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -3 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/no_chat.d43a98d0.svg";
export { SvgComponent as ReactComponent };